import _ from 'lodash'
import { computed } from 'vue'
import { useCurrentUserStore } from '@/pinia/CurrentUserStore';

const permissions = computed(() => {
    let userStore = useCurrentUserStore();
    return userStore.user.permissions;
})

const currentTenant = computed(() => {
    let userStore = useCurrentUserStore();
    return "company." + userStore.internal_company;
});

const isAdministrator = computed(() => {
    let userStore = useCurrentUserStore();
    return userStore.user.is_administrator;
})

export function can(key){
    if(isAdministrator.value == "true") {
        return true;
    }

    let value = _.get(permissions.value, "roles." + key);
    // console.log("Permisison Role", "roles." + key, value);
        if(_.isArray(value) && value[0] == true){
            return true;
        }
        if(value === true){
            return true;
        }
        value = _.get(permissions.value, currentTenant.value + "." + key);
        // console.log("Permisison Tenant", currentTenant.value + "." + key, value);
        if(_.isArray(value) && value[0] == true){
            return true;
        }
        if(value === true){
            return true;
        }
    return false;
}

export function cannot(key){
    return !can(key);
}
